var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_2215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13.02,
    width: 24,
    height: 18.74,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.413 31.75H30.9131C32.8696 31.75 34 30.6196 34 28.3805V16.3804C34 14.1522 32.8587 13.0217 30.587 13.0217H13.087C11.1304 13.0217 10 14.1413 10 16.3804V28.3805C10 30.6304 11.1413 31.75 13.413 31.75ZM13.3478 30.087C12.2609 30.087 11.663 29.5109 11.663 28.3805V16.3804C11.663 15.2609 12.2609 14.6848 13.3478 14.6848H30.6522C31.7174 14.6848 32.337 15.2609 32.337 16.3913V28.3913C32.337 29.5109 31.7174 30.087 30.6522 30.087H13.3478ZM22.0218 25.2827C22.7826 25.2827 23.5217 24.9674 24.2826 24.2174L33.1087 15.5435L31.9783 14.4022L23.3369 22.9348C22.8696 23.4022 22.4456 23.6087 22.0218 23.6087C21.587 23.6087 21.163 23.3913 20.7065 22.9348L12.0217 14.3587L10.8804 15.5L19.7609 24.2174C20.5217 24.9674 21.25 25.2827 22.0218 25.2827ZM31.8695 30.3261L33 29.1848L25.9674 22.2391L24.837 23.3696L31.8695 30.3261ZM11.0326 29.1957L12.163 30.337L19.2065 23.3696L18.0652 22.2391L11.0326 29.1957Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_2215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.75,
    fill: "white",
    transform: "translate(10 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.f6bf2d98f4ad00ce2531855743b3ae48.svg";
export { ForwardRef as ReactComponent };